import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";

const saveSchema = z.object({
  sessionId: z.string().uuid(),
  email: z.string().trim().email().max(254),
  fullName: z.string().trim().max(100).optional(),
  phone: z.string().trim().max(30).optional(),
  isGift: z.boolean().optional(),
  referralCode: z.string().trim().max(20).optional(),
});

/** Saves an unfinished checkout for cart reminder emails, server-side only. */
export const saveAbandonedCheckout = createServerFn({ method: "POST" })
  .inputValidator((data) => saveSchema.parse(data))
  .handler(async ({ data }) => {
    const { supabaseAdmin } = await import("@/integrations/supabase/client.server");
    const { error } = await supabaseAdmin.rpc("upsert_abandoned_checkout", {
      p_session_id: data.sessionId,
      p_email: data.email,
      p_is_gift: data.isGift ?? false,
      ...(data.fullName ? { p_full_name: data.fullName } : {}),
      ...(data.phone ? { p_phone: data.phone } : {}),
      ...(data.referralCode ? { p_referral_code: data.referralCode } : {}),
    });
    if (error) console.error("upsert_abandoned_checkout failed:", error.message);
    return { ok: !error };
  });

/** Marks this visit's checkout as finished so no cart reminder is sent. */
export const completeAbandonedCheckout = createServerFn({ method: "POST" })
  .inputValidator((data) => z.object({ sessionId: z.string().uuid() }).parse(data))
  .handler(async ({ data }) => {
    const { supabaseAdmin } = await import("@/integrations/supabase/client.server");
    const { error } = await supabaseAdmin.rpc("mark_checkout_completed", {
      p_session_id: data.sessionId,
    });
    if (error) console.error("mark_checkout_completed failed:", error.message);
    return { ok: !error };
  });
